<script>
	import Navbar from "./components/Navbar.svelte";
	import Footer from "./components/Footer.svelte";
	import { api_ingestEntitySet } from "./stores.js";

	const debug = false;
	if (debug) {
		console.log("\n\n=== DEBUG MODE ===\n\n");
	}

	let message =
		"You'll be able to upload information once you've completed the previous steps.";

	let setname = "fakenews";
	let date = new Date();
	date =
		date.getFullYear() -
		2000 +
		("0" + (date.getMonth() + 1)).slice(-2) +
		date.getDate() +
		("0" + (date.getMinutes() + 1)).slice(-2) +
		"_";
	let finalname;
	$: if (setname) {
		setname = setname.toLowerCase();
		setname = setname.replace(/[^a-z0-9_]+/, "");
		finalname = date + setname.replaceAll(" ", "").toLowerCase();
		payload.setname = finalname;
		console.log("payload", payload);
	}

	let category;
	$: if (category !== undefined) {
		payload.category = category;
		console.log("payload", payload);
	}

	let payload = { setname: finalname, category, covariates: [] };
	let text = "";
	$: payload["setname"] = finalname;

	let disabled = true;
	let code = "";
	let correctCode = SECRET_CODE;
	$: disabled = code !== correctCode;

	let uploadCount = 0;
	const uploadEntities = () => {
		uploadCount = 0; // reset value
		console.log("filenames length: ", filenames.length);
		covariates.forEach((cov, fi) => {
			uploadCount += 1;
			payload.covariates.push(cov);
			uploadedFilenames = [...uploadedFilenames, cov.filename];
		});
		console.log("final payload", payload);
		if (!debug) {
			ingestEntitySet(payload);
		} else {
			uploadMessage = "DEBUG MODE: NOT UPLOADING";
		}
	};

	let uploadedFilenames = [];

	let covariateCols = 0;
	let covariateRows = 0;
	let covariates = [];
	let missing = false;
	let missingCols = [];
	let filenames = [];
	let disableButtonAppearance = false;

	const parseText = (text) => {
		// reset values
		covariateCols = 0;
		covariateRows = 0;
		covariates = [];
		missing = false;
		missingCols = [];
		filenames = [];
		disableButtonAppearance = false;

		text = text.split("\n");
		if (text == "") {
			covariateCols = [];
		} else {
			covariateCols = text[0].split("\t");
		}
		covariateRows = text.slice(1);
		missing = false;

		missingCols = [];
		if (!covariateCols.includes("source_url")) {
			missing = true;
			missingCols.push("source_url");
		}
		if (!covariateCols.includes("filename")) {
			missing = true;
			missingCols.push("filename");
		}
		if (!covariateCols.includes("retrieve_date")) {
			missing = true;
			missingCols.push("retrieve_date");
		}
		if (!covariateCols.includes("entity_type")) {
			missing = true;
			missingCols.push("entity_type");
		}

		if (missingCols.length > 0) {
			console.log("missing", missingCols);
			disableButtonAppearance = true;
			return;
		} else {
			disableButtonAppearance = false;
		}

		covariateRows.forEach((row) => {
			let obj = {};
			row.split("\t").forEach((col, i) => {
				if (covariateCols[i] === "headline") {
					col = encodeURIComponent(col);
				}
				obj[covariateCols[i]] = col;
			});
			obj["entity_url"] = obj["source_url"];
			covariates.push(obj);
		});
		console.log("covariates/headlines", covariates);
		filenames = covariates.map((c) => c.filename);
		console.log("filenames", filenames);
		console.log("initialize empty payload", payload);
	};
	$: parseText(text);

	let uploadMessage = "Whoops, something went wrong. Try again later.";
	async function ingestEntitySet(entity_set_settings) {
		console.log("Send data to server...");
		const resp = await fetch($api_ingestEntitySet, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				entity_set_settings: entity_set_settings,
			}),
		});
		const response = await resp.json();
		if (response.success === "true") {
			uploadMessage = "Success!";
		}
	}
</script>

<Navbar />
<main>
	<h1 style="text-align: center">📤 Upload entity URL and covariates</h1>

	{#if !disabled}
		<div>
			<h3>Step 1: Category</h3>
			<p>
				Ensure the information you're about to upload only belong to one
				category. If you have multiple categories, upload each category
				separately.
			</p>
			<label for="category" />
			<select name={"category"} bind:value={category}>
				<option value="news">news</option>
				<option value="opinion">opinion</option>
				<option value="sensational">sensational</option>
				<option value="ads">ads</option>
			</select>
		</div>
		<div>
			<h3>Step 2: Set name</h3>
			<p>
				Provide a brief unique identifier/label. All your data will be
				uploaded as a single set.
			</p>
			<input bind:value={setname} maxlength="15" />
			<p>
				Set name: <strong>{finalname}</strong>
			</p>
		</div>

		<h3>Step 3: Upload information</h3>
		<p>
			Paste your information/covariate sheet from Google Sheets or Excel
			(it should be tab-separated). See example <a
				href="https://docs.google.com/spreadsheets/d/1ivqwchobkeuzgm-yS8J2E37dXsp_a5xBOxOV4Twbxzg/edit#gid=336989104"
				target="_blank"
			>
				here</a
			>.

			<br /><br />Required columns:

			<code>source_url, filename, entity_type, retrieve_date</code>
		</p>
		<div>
			<textarea class="textarea-covariate" bind:value={text} />
		</div>

		{#if text !== "" && !missing}
			<strong style="color: red;"
				>Detected {covariateCols.length} columns and {covariateRows.length}
				rows/headlines.</strong
			>
			<p>- <code>{covariateCols}</code></p>
			<!-- <p>
				Optional covariate columns: <code>{covariateCols.slice(3)}</code
				>
			</p> -->
		{:else if text !== "" && missing}
			<span style="color: red;"
				>Missing columns: <code> {missingCols}</code>
			</span>
		{/if}

		<h3>Step 4: Confirm upload</h3>
		{#if disableButtonAppearance}
			<p>{message}</p>
		{:else}
			<button disabled={false} on:click|preventDefault={uploadEntities}>
				Upload</button
			>
		{/if}
	{:else}
		<p>Enter key to continue</p>
		<input type="text" bind:value={code} />
	{/if}

	{#if uploadCount === covariates.length && uploadCount !== 0}
		<p>Uploading {uploadedFilenames.length} entities...</p>

		{#if uploadedFilenames.length > 0}
			<ol>
				{#each uploadedFilenames as item}
					<li>{item}</li>
				{/each}
			</ol>
		{/if}

		<p style="text-align: center"><strong>{uploadMessage}</strong></p>
	{/if}
</main>

<Footer />

<style>
	@media (max-width: 700px) {
		main {
			padding-left: 8%;
			padding-right: 8%;
		}
	}
	.textarea-covariate {
		width: 100%;
		height: 100px;
		border: 1px solid #ccc;
		padding: 10px;
		border-radius: 3px;
	}
	.primary {
		color: green;
	}
	.sm {
		font-size: 1em;
		padding: 0.1em;
	}
</style>
